import moment from "moment-timezone";

export type Timezone =
  | "America/New_York"
  | "America/Chicago"
  | "America/Denver"
  | "America/Los_Angeles"
  | "America/Anchorage"
  | "Pacific/Honolulu";

// map timezone to locale that moment-timezone can use to compute UTC Offset
const timezoneMap: { [key: string]: Timezone } = {
  EST: "America/New_York",
  CST: "America/Chicago",
  MST: "America/Denver",
  PST: "America/Los_Angeles",
  AKST: "America/Anchorage",
  HAST: "Pacific/Honolulu",
};

export const convertDateToLocalDeadlineMoment = (
  dateValue?: string | number | Date | null,
  timezone?: string | null
): moment.Moment | null => {
  if (!dateValue) {
    return null;
  }

  const dateOnly = moment.utc(dateValue).format("YYYY-MM-DD");
  const sourceTimezone = timezoneMap[timezone?.toUpperCase() ?? ""] ?? "UTC";
  const zonedDate = moment.tz(dateOnly, "YYYY-MM-DD", sourceTimezone).endOf("day");
  const localZone = moment.tz.guess();

  return zonedDate.clone().tz(localZone).add(1, "second").startOf("minute");
};

export const formatProjectTimezoneDeadline = (
  dateValue?: string | number | Date | null,
  timezone?: string | null
): string => {
  if (!dateValue) {
    return "--";
  }

  const dateOnly = moment.utc(dateValue).format("YYYY-MM-DD");
  const sourceTimezone = timezoneMap[timezone?.toUpperCase() ?? ""] ?? "UTC";
  const zonedDate = moment.tz(dateOnly, "YYYY-MM-DD", sourceTimezone).endOf("day");

  return zonedDate.isValid() ? zonedDate.format("DD-MM-YYYY hh:mm a z") : "--";
};

export default timezoneMap;
